import { collections } from "@/mocks/heigua";

export default function Collections() {
  return (
    <section id="collections" className="bg-cream-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-ember-600">
              <span className="h-px w-8 bg-ember-500" />
              ARCHIVE
            </p>
            <h2 className="font-serif text-2xl font-bold tracking-tight text-ink-950 md:text-4xl">
              专题合集 · 慢慢深挖
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-ink-600 md:text-base">
              快讯吃鲜，专题要慢。我们把同一根瓜线整理成可回溯的合集档案，连成一条完整的来龙去脉。
            </p>
          </div>
          <a
            href="#zones"
            className="inline-flex shrink-0 items-center whitespace-nowrap text-sm font-medium text-ember-600 hover:text-ember-700"
          >
            浏览全部栏目
            <i className="ri-arrow-right-line ml-1.5" />
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((c) => (
            <a key={c.title} href="#vault" className="group overflow-hidden rounded-xl bg-white ring-1 ring-cream-200">
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.title}专题合集封面`}
                  title={`${c.title} 独家内幕合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-ink-950/70 px-2.5 py-1 text-xs font-medium text-cream-50 backdrop-blur-sm">
                  {c.tag}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between text-xs text-ink-400">
                  <span>{c.meta}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-timer-line" />
                    {c.read}
                  </span>
                </div>
                <h3 className="mt-2.5 font-serif text-lg font-bold leading-snug text-ink-950 transition-colors group-hover:text-ember-600">
                  {c.title}
                </h3>
                <p className="mt-1.5 text-sm text-ink-600">{c.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}